// @core/api/endpoints/billing/get_price.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  GetPriceResponse,
} from '../../../types/billing';

const BASE_PATH = '/billing';

/**
 * Get price by ID
 * Retrieves a price by its unique identifier. Returns the pricing details including model, tiers, and billing period configuration.
 */
export async function GetPrice(
  id: string,
  options?: RequestOptions
): Promise<GetPriceResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/prices/:id`;
  requestPath = requestPath.replace(':id', encodeURIComponent(id));
  const requestOptions = options;
  return client.get<GetPriceResponse>(requestPath, { ...requestOptions });
}
